import React from 'react';
import PropTypes from 'prop-types';
import LabeledRadio from '../LabeledRadio/LabeledRadio';
import './LabeledRadioWithDescription.scss';

const LabeledRadioWithDescription = (props) => {
    function onClick(e) {
        e.preventDefault();
        props.onRadioClick(props.customerType);
    }

    return(
        <div className="col-xs-12" onClick={onClick}>
            <LabeledRadio 
                checked={props.checked}
                glyph={props.glyph}
                id={props.id}
                label={props.label}
                name={props.name}
                value={props.value}
                onChange={onClick}/>
            <p>
                {props.description}
            </p>
        </div>
    );
};

LabeledRadioWithDescription.propTypes = {
    checked: PropTypes.bool,
    description: PropTypes.string,
    glyph: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    onRadioClick: PropTypes.func,
    value: PropTypes.string
};

export default LabeledRadioWithDescription;


// WEBPACK FOOTER //
// ./src/components/base/LabeledRadioWithDescription/LabeledRadioWithDescription.js